import { CartLinesUpdateEvent } from '@shopify/events';
if (!customElements.get('au-cart-add')) {
  customElements.define('au-cart-add', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('button').addEventListener('click', () => this.add());
    }
    async add() {
      if (this.busy) return;
      this.busy = true;
      const button = this.querySelector('button');
      const label = button.textContent;
      const status = this.querySelector('[role="status"]');
      button.disabled = true;
      button.textContent = this.dataset.adding;
      status.textContent = '';
      const update = CartLinesUpdateEvent.createPromise();
      this.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'cart',lines:[{id:this.dataset.variant,quantity:1}],promise:update.promise}));
      try {
        const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(e => e.dataset.sectionId).filter(Boolean))];
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(this.dataset.variant),quantity:1}],sections,sections_url:location.pathname})});
        if (!response.ok) throw new Error('add');
        const added = await response.json();
        const cartResponse = await fetch(this.dataset.cartUrl + '.js', {headers:{Accept:'application/json'}});
        if (!cartResponse.ok) throw new Error('cart');
        const cart = await cartResponse.json();
        update.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{sections:added.sections,items:cart.items,itemCount:cart.item_count,source:'au-cart-add',didError:false}});
      } catch (error) {
        update.reject(error);
        status.textContent = this.dataset.error;
      } finally {
        this.busy = false;
        button.disabled = false;
        button.textContent = label;
      }
    }
  });
}
